<template>
  <span>
    <v-dialog v-model="dialog" persistent max-width="350">
      <template v-slot:activator="{ on }">
        <v-btn v-if="button_type== 'icon'" icon v-on="on">
          <v-icon :color="action.button_color">{{$vuetify.icons[action.button_icon]}}</v-icon>
        </v-btn>
        <!-- When button has a label -->
        <v-btn
          v-else-if="button_type== 'button'"
          :outline="!(action.no_outline == true)"
          :small="small"
          :round="round"
          :color="action.button_color"
          v-on="on"
        >
          <v-icon v-if="action.button_icon" small class="pr-1">{{$vuetify.icons[action.button_icon]}}</v-icon>
          {{ $t(action.button_label) }}
        </v-btn>
        <v-btn v-else-if="button_type== 'icon-button'" small dark icon color="grey" v-on="on">
          <v-icon small :color="action.button_color">{{$vuetify.icons[action.button_icon]}}</v-icon>
        </v-btn>
        <v-list-tile v-else v-on="on">
          <v-list-tile-title>{{$t('assets_manager.list.menu.delete')}}</v-list-tile-title>
        </v-list-tile>
      </template>
      <v-card>
        <v-card-title class="headline">{{$t(headline)}}</v-card-title>
        <v-card-text v-if="desc" v-html="$t(desc)">{{ $t(desc) }}</v-card-text>

        <v-card-text v-if="add_note">
          <v-textarea
            placeholder="Write something for rightholder."
            outline
            v-model="action.payload.note"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :color="action.btn_yes_color ? action.btn_yes_color : 'green darken-1'"
            flat
            @click="confirm"
          >{{ action.btn_yes_text ? $t(action.btn_yes_text) : $t("rms.buttons.yes")}}</v-btn>
          <v-btn
            :color="action.btn_no_color ? action.btn_no_color : 'red darken-1'"
            flat
            @click="dialog = false"
          >{{ action.btn_no_text ? $t(action.btn_no_text) : $t("rms.buttons.no")}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>
<script>
export default {
  name: "ConfirmationDialog",

  props: {
    action: Object,
    headline: String,
    desc: String,
    button_type: String,
    round: Boolean,
    small: Boolean,
    add_note: {
      default: false
    }
  },
  data: () => ({
    dialog: false,
    note_text: null
  }),
  methods: {
    async confirm() {
      await this.action.method(this.action.payload ? this.action.payload : "");
      this.dialog = false;
    }
  }
};
</script>


